import RouterSwitch from './RouterSwitch'

export default RouterSwitch
// eslint-disable-next-line import/export
export * from './RouterSwitch'
